import axiosClient from "../../../api/axiosClient";

export const getProjects = () => {
  return axiosClient.get("/api/pms/projects");
};

export const getProjectDetail = (id) => {
  return axiosClient.get(`/api/pms/projects/${id}`);
};
